
import { CtrlCollection } from '@yuigoto/ctrl';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { GlamboxComissionControl } from 'controls/GlamboxComissionControl';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import React from 'react';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { Container } from "components/grid/Container";
import { Row } from "components/grid/Row";
import { Col } from "components/grid/Col";
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';

export class CreateGlamboxComission extends React.Component {
  constructor(props){
    super(props);
    this.renderFormContent();
  }

  renderFormContent = () => {
    this.collection = new CtrlCollection();

    for (let i in GlamboxComissionControl) {
      if (Array.isArray(GlamboxComissionControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n in GlamboxComissionControl[i]) {
          tempCollection.add(GlamboxComissionControl[i][n]);
        }
        this.collection.add(tempCollection);
      }
      else {
        this.collection.add(GlamboxComissionControl[i])
      }

    }
    

  }

  renderStatusOptions = (props, options) => {
    return (
      <select onChange={(e) => props.onChange(e.target.value)}
        value={props.value}>
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>);
  }

  createComission = (e) => {
    e.preventDefault();

    let glamboxPaymentData = this.collection.toObject(true);
    let dateFrom = new Date(
      glamboxPaymentData.dateFrom.split("/").reverse().join("-") + "T00:00:00"
    );

    let dateTo = new Date(
      glamboxPaymentData.dateTo.split("/").reverse().join("-") + "T00:00:00"
    );

    glamboxPaymentData.dateFrom = dateFrom;
    glamboxPaymentData.dateTo = dateTo;

    glamboxPaymentData.influencerStatusRestriction = parseInt(glamboxPaymentData.influencerStatusRestriction);

    glamboxPaymentData.paymentAnnual = parseInt(glamboxPaymentData.paymentAnnual);
    glamboxPaymentData.paymentMonth = parseInt(glamboxPaymentData.paymentMonth);
    glamboxPaymentData.paymentSixMonth = parseInt(glamboxPaymentData.paymentSixMonth);
    glamboxPaymentData.businessUnity = parseInt(glamboxPaymentData.businessUnity);

    let requestBody = Object.assign({}, glamboxPaymentData);

    this.createComissionRequest(requestBody);

  }

  createComissionRequest = (requestBody) => {
    ExecuteRequest(
      GlamboxEndpoints.GlampartnerPaymentRegistry.createGlambox,
      requestBody,
      "POST",
      {
        Authorization: this.props.token
      },
      null,
      (response) => {
        const { statusCode, result } = response;

        if (statusCode === 200) {
          this.props.publishSuccessAlert("Comissão criada com sucesso");
        } else {
          this.props.publishErrorAlert(result.message);
        }
        this.props.loaderHide();
      }
    );

  }

  render() {
    return (

      <div className={"mb-2"}>
        <h3>Comissão Glambox</h3>
        <div className={"level-2"}>
        <div className={"gb-contentblock p-4 level-2 mb-2"}>
          <form onSubmit={this.createComission}>
            {ControlRenderer.renderCollection(this.collection)}
            <div >
              <button className={"btn btn-sm btn-light-pink"}>
                Enviar
              </button>
            </div>
          </form>
        </div>
      </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data.Authorization

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

CreateGlamboxComission = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateGlamboxComission);